import * as qs from 'qs';
export const stringifyQueryObject = (query) => {
    return qs.stringify(query);
};
//# sourceMappingURL=stringifyQueryObject.js.map